import type { DeleteIvaSchedule } from '@rtkwlf/rendall';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';

import { useRendallApi } from '../use-rendall-api';

export const useDeleteIvaSchedule = (
  options?: UseMutationOptions<void, Error, DeleteIvaSchedule[]>,
) => {
  const api = useRendallApi();
  const { selectedOrganization } = useOrganizationContext();

  return useMutation({
    mutationFn: (scanIvaParams: DeleteIvaSchedule[]) =>
      api.deleteIvaSchedules({
        deleteIvaSchedulesInput: {
          _delete: scanIvaParams,
        },
        organizationId: selectedOrganization.id,
      }),
    ...options,
  });
};
